export default __webpack_public_path__ + "static/media/taskList.69966b6f.svg";